<app-details-loader *ngIf="loadFlag || errorMsg" [errorMsg]="errorMsg" [Height]="'70vh'" [LoaderMarginTop]="'19%'"></app-details-loader>

<ng-container *ngIf="!loadFlag && !errorMsg">
  <a routerLink="/events-and-logs" class="ev-back">&lsaquo; Back to events &amp; logs</a>

  <div class="ev-head">
    <div>
      <div class="ev-head__t">{{eventData.description ? (eventData.description | camalizeStr : true).replace('usd', 'USD') : '--'}}</div>
      <div class="ev-head__meta">
        <payarc-status-badge *ngIf="eventData.type || eventData.event_type" [status]="eventData.description || ''" [label]="eventData.type || eventData.event_type"></payarc-status-badge>
        <code *ngIf="eventData.id">{{eventData.id}}</code>
        <span *ngIf="eventData.created_at" class="ev-head__date">{{eventData.created_at | dateFormat: 'MM/dd/yyyy hh:mm a'}}</span>
      </div>
    </div>
  </div>

  <payarc-detail-card title="Event details" [rows]="eventDetailRows"></payarc-detail-card>

  <payarc-section-card heading="Event data (JSON)" sub="Read-only" class="ev-json-card">
    <ng-container *ngIf="eventData; else noData">
      <ngx-json-viewer [json]="eventData" [expanded]="false"></ngx-json-viewer>
    </ng-container>
    <ng-template #noData>No details available.</ng-template>
  </payarc-section-card>
</ng-container>
